import React from 'react';

// Static 2×2 grid on the light section background, per the updated design — this replaced the dark
// autoplay carousel the other landing pages still use.
const QUOTES = [
    { q: 'My kind of utopia is to get a conversational application process — AI accepted through to pre-screen initial DD without us physically doing anything.', a: '— Peter Evison, COO, EHE Capital' },
    { q: 'Putting a deal in front of a VC with the Diligentsia outputs alongside the deck. You have answered 60 questions they did not even ask yet.', a: '— Fractional CFO, CFO Centre' },
    { q: 'I think there is definitely a market need for a platform like this.', a: '— Kevin Jackson, Chairman, AI Forge' },
    { q: 'A living, breathing data room that syncs with your documents to maintain continuous readiness.', a: '— Founder, advanced medtech company (active fundraising)' },
];

const VCQuotesSection = () => (
    <section className="lp-vcquotes">
        <div className="lp-vcquotes-inner">
            <div className="lp-vcquotes-head" data-lp-reveal>Trusted by investors and founders who know due diligence.</div>

            <div className="lp-vcquotes-grid">
                {QUOTES.map((item, i) => (
                    <div className="lp-vcquotes-card" key={i} data-lp-reveal data-lp-delay={i * 80}>
                        <p className="lp-vcquotes-quote">{item.q}</p>
                        <div className="lp-vcquotes-attrib">{item.a}</div>
                    </div>
                ))}
            </div>

            <p className="lp-vcquotes-foot" data-lp-reveal>Trusted by 40+ VCs and their portfolio companies.</p>
        </div>
    </section>
);

export default VCQuotesSection;
